/**
 * sw.js
 *
 * This function takes a SwitchMap and returns a SwitchFunction which
 * can be called with a case property and extra args to match with
 * function
 *
 * @example
 *  sw({
 *    foo: i => i + 2,   // 5
 *    bar: 'baz',        // bar
 *    default: null,     // null
 *  })('foo', 3)
 *
 * @param {SwitchMap} cases - A map of string cases to value or CaseFunction call
 * @returns {SwitchFunction}
 */

export default (cases: Record<string, Function>) =>
  (c: string, ...args: any) => {
    const f = {}.hasOwnProperty.call(cases, c) ? cases[c] : cases.default

    return f instanceof Function ? f(...args) : f
  }
